import { render, staticRenderFns } from "./permissionSettings.vue?vue&type=template&id=3c3570ea&scoped=true&"
import script from "./permissionSettings.vue?vue&type=script&lang=js&"
export * from "./permissionSettings.vue?vue&type=script&lang=js&"
import style0 from "./permissionSettings.vue?vue&type=style&index=0&id=3c3570ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3570ea",
  null
  
)

export default component.exports